// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.organizator {
  display: flex;
  flex-direction: column;
  border-radius: 1.5rem;
  padding: 24px 16px;
  grid-gap: 20px;
  min-height: 600px;
}
@media all and (min-width: 1280px) {
  .organizator {
    border-radius: 2rem;
    padding: 36px;
    grid-gap: 0 42px;
    display: grid;
    grid-template-areas: "image logo" "image description" "image socials";
    min-height: auto;
    grid-template-rows: auto 1fr auto; /* Управляем высотой строк */
    grid-template-columns: 490px auto;
  }
}
.organizator--alfa-bank {
  background-color: #EF3124;
}
.organizator--vsk {
  background-color: #4544EE;
}
.organizator--h {
  background-color: #2078FE;
}
.organizator--vtb {
  background-color: #002882;
}
.organizator--robo-finance {
  background-color: #fbfbfb;
}
.organizator--x-5 {
  background-color: #5FAF2D;
}
.organizator--sport-master {
  background-color: #1551E5;
}
.organizator--ar {
  background-color: #151515;
}
.organizator--kontur {
  background-color: #fbfbfb;
}
.organizator__logo {
  grid-area: logo;
}
.organizator__image {
  grid-area: image;
}
.organizator__image img {
  width: 100%;
}
.organizator__description {
  grid-area: description;
  flex-grow: 1;
}
@media all and (min-width: 1280px) {
  .organizator__description {
    margin-top: 20px;
    flex-grow: unset;
  }
}
.organizator__socials {
  grid-area: socials;
  display: flex;
  grid-gap: 1rem;
}
.organizator__link {
  display: flex;
  align-items: center;
  grid-gap: 4px;
}
.organizator__link--white-75 {
  color: rgba(251, 251, 251, 0.7490196078);
  transition-duration: 250ms;
}
@media all and (hover) {
  .organizator__link--white-75:hover {
    color: rgba(251, 251, 251, 0.5019607843);
  }
  .organizator__link--white-75:hover img {
    filter: opacity(0.75);
  }
}
.organizator__link--black-75 {
  color: rgba(21, 21, 21, 0.7490196078);
  transition-duration: 250ms;
}
.organizator__link--black-75 img {
  filter: invert(1);
}
@media all and (hover) {
  .organizator__link--black-75:hover {
    color: rgba(21, 21, 21, 0.5019607843);
  }
  .organizator__link--black-75:hover img {
    filter: invert(0.75);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Organizator/Organizator.scss","webpack://./src/styles/variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;AAAF;AAEE;EARF;IASI,mBAAA;IACA,aAAA;IACA,gBAAA;IACA,aAAA;IACA,qEACA;IAGA,gBAAA;IAEA,iCAAA,EAAA,4BAAA;IACA,iCAAA;EAHF;AACF;AAME;EACE,yBCTQ;ADKZ;AAOE;EACE,yBCZE;ADON;AAQE;EACE,yBCfA;ADSJ;AASE;EACE,yBClBE;ADWN;AAUE;EACE,yBCVQ;ADEZ;AAWE;EACE,yBCxBE;ADeN;AAYE;EACE,yBC3BW;ADiBf;AAaE;EACE,yBC5BQ;ADiBZ;AAcE;EACE,yBC1BQ;ADcZ;AAeE;EACE,eAAA;AAbJ;AAiBE;EACE,gBAAA;AAfJ;AAiBI;EACE,WAAA;AAfN;AAmBE;EACE,sBAAA;EACA,YAAA;AAjBJ;AAmBI;EAJF;IAKI,gBAAA;IACA,gBAAA;EAhBJ;AACF;AAmBE;EACE,kBAAA;EACA,aAAA;EACA,cAAA;AAjBJ;AAoBE;EACE,aAAA;EACA,mBAAA;EACA,aAAA;AAlBJ;AAoBI;EACE,wCC/DK;EDgEL,0BAAA;AAlBN;AAoBM;EACE;IACE,wCCnEC;EDiDT;EAoBQ;IACE,qBAAA;EAlBV;AACF;AAuBI;EACE,qCCpFK;EDqFL,0BAAA;AArBN;AAuBM;EACE,iBAAA;AArBR;AAwBM;EACE;IACE,qCC5FC;EDsET;EAwBQ;IACE,oBAAA;EAtBV;AACF","sourcesContent":["@import 'src/styles/variables';\n\n.organizator {\n  display: flex;\n  flex-direction: column;\n  border-radius: 1.5rem;\n  padding: 24px 16px;\n  grid-gap: 20px;\n  min-height: 600px;\n\n  @media all and (min-width: $desktop) {\n    border-radius: 2rem;\n    padding: 36px;\n    grid-gap: 0 42px;\n    display: grid;\n    grid-template-areas:\n    \"image logo\"\n    \"image description\"\n    \"image socials\";\n    min-height: auto;\n\n    grid-template-rows: auto 1fr auto; /* Управляем высотой строк */\n    grid-template-columns: 490px auto;\n  }\n\n\n  &--alfa-bank {\n    background-color: $alfa-bank;\n  }\n\n  &--vsk {\n    background-color: $vsk;\n  }\n\n  &--h {\n    background-color: $h;\n  }\n\n  &--vtb {\n    background-color: $vtb;\n  }\n\n  &--robo-finance {\n    background-color: $white-100;\n  }\n\n  &--x-5 {\n    background-color: $x-5;\n  }\n\n  &--sport-master {\n    background-color: $sport-master;\n  }\n\n  &--ar {\n    background-color: $black-100;\n  }\n\n  &--kontur {\n    background-color: $white-100;\n  }\n\n  &__logo {\n    grid-area: logo;\n    //height: fit-content;\n  }\n\n  &__image {\n    grid-area: image;\n\n    img {\n      width: 100%;\n    }\n  }\n\n  &__description {\n    grid-area: description;\n    flex-grow: 1;\n\n    @media all and (min-width: $desktop) {\n      margin-top: 20px;\n      flex-grow: unset;\n    }\n  }\n\n  &__socials {\n    grid-area: socials;\n    display: flex;\n    grid-gap: 1rem;\n  }\n\n  &__link {\n    display: flex;\n    align-items: center;\n    grid-gap: 4px;\n\n    &--white-75 {\n      color: $white-75;\n      transition-duration: 250ms;\n\n      @media all and (hover) {\n        &:hover {\n          color: $white-50;\n\n          img {\n            filter: opacity(0.75);\n          }\n        }\n      }\n    }\n\n    &--black-75 {\n      color: $black-75;\n      transition-duration: 250ms;\n\n      img {\n        filter: invert(1);\n      }\n\n      @media all and (hover) {\n        &:hover {\n          color: $black-50;\n\n          img {\n            filter: invert(0.75);\n          }\n        }\n      }\n    }\n  }\n}","$headerHeightMobile: 60px;\n$headerHeightDesktop: 80px;\n\n$desktop: 1280px;\n\n\n// accents\n$main-blue-gradient: #100;\n$main-dark-blue: #1F106D;\n$main-mid-blue-100: #1F48B1FF;\n$main-mid-blue-50: #1F48B180;\n$main-light-blue: #A1C7FF;\n$hover-main-blue: #331CAA;\n$pressed-main-blue: #011C5A;\n$progress-bar-red: #D62B1F;\n$progress-dot-disabled: #D9D9D9;\n\n// brands\n$alfa-bank: #EF3124;\n$vsk: #4544EE;\n$h: #2078FE;\n$vtb: #002882;\n$robo-finance: #00BF6E;\n$x-5: #5FAF2D;\n$sport-master: #1551E5;\n\n// black\n$black-100: #151515FF;\n$black-75: #151515BF;\n$black-50: #15151580;\n$black-25: #15151540;\n\n// white\n$white-100: #FBFBFBFF;\n$white-75: #FBFBFBBF;\n$white-50: #FBFBFB80;\n$white-25: #FBFBFB40;\n\n// input\n$input-background: #F1F5F9;\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
